import { render, staticRenderFns } from "./PowerContactTable.vue?vue&type=template&id=24842342&scoped=true"
import script from "./PowerContactTable.vue?vue&type=script&lang=js"
export * from "./PowerContactTable.vue?vue&type=script&lang=js"
import style0 from "./PowerContactTable.vue?vue&type=style&index=0&id=24842342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24842342",
  null
  
)

export default component.exports